/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";

interface Props {
  stages: string[];
  currentStages: string[];
  setCurrentStages: React.Dispatch<React.SetStateAction<string[]>>;
}

// Styles defined outside the component
const smallerTextStyle = { fontSize: "0.8rem" };
const reducedSpacingStyle = { margin: "2px 0" };

const StageSettings: React.FC<Props> = ({ stages, currentStages, setCurrentStages }) => {
  const [isRemoved, setIsRemoved] = useState(false);
  const [isMovedIn, setIsMovedIn] = useState(false);

  const isActive = currentStages.includes("Active");
  const activeSubStages = currentStages.filter(stage => stages.includes(stage));

  const handleActiveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setCurrentStages(["Active", ...stages, ...currentStages]);
    } else {
      setCurrentStages(currentStages.filter(stage => !stages.includes(stage) && stage !== "Active"));
    }
  };

  const handleSubStageChange = (stage: string) => {
    let updatedStages = [] as string[];
    if (currentStages.includes(stage)) {
      updatedStages = currentStages.filter(stageName => stageName !== stage);
    } else {
      updatedStages = [...currentStages, stage];
    }

    // Check if all sub-stages are selected
    const allSubStagesSelected = stages.every(subStage => updatedStages.includes(subStage));
    if (allSubStagesSelected && !updatedStages.includes("Active")) {
      updatedStages.push("Active");
    } else if (!allSubStagesSelected && updatedStages.includes("Active")) {
      updatedStages = updatedStages.filter(stageName => stageName !== "Active");
    }

    setCurrentStages(updatedStages);
  };

  useEffect(() => {
    setIsRemoved(currentStages.includes("Removed"));
    setIsMovedIn(currentStages.includes("Moved In"));
  }, [currentStages]);

  return (
    <FormGroup>
      <FormControlLabel
        style={reducedSpacingStyle}
        control={
          <Checkbox
            size="small"
            checked={isActive}
            indeterminate={activeSubStages.length > 0 && !isActive}
            onChange={handleActiveChange}
          />
        }
        label={<span style={smallerTextStyle}>Active</span>}
      />
      <FormGroup style={{ marginLeft: 20 }}>
        {stages.map(stage => (
          <FormControlLabel
            style={reducedSpacingStyle}
            key={stage}
            control={
              <Checkbox
                size="small"
                checked={activeSubStages.includes(stage)}
                onChange={() => handleSubStageChange(stage)}
              />
            }
            label={<span style={smallerTextStyle}>{stage}</span>}
          />
        ))}
      </FormGroup>
      <FormControlLabel
        style={reducedSpacingStyle}
        control={<Checkbox size="small" checked={isRemoved} onChange={(e) => setCurrentStages(e.target.checked ? [...currentStages, "Removed"] : currentStages.filter(stage => stage !== "Removed"))} />}
        label={<span style={smallerTextStyle}>Removed</span>}
      />
      <FormControlLabel
        style={reducedSpacingStyle}
        control={<Checkbox size="small" checked={isMovedIn} onChange={(e) => setCurrentStages(e.target.checked ? [...currentStages, "Moved In"] : currentStages.filter(stage => stage !== "Moved In"))} />}
        label={<span style={smallerTextStyle}>Moved In</span>}
      />
    </FormGroup>
  );
};

export default StageSettings;
